module.exports = __webpack_public_path__ + "a78db9c0b4e2754dfb3eced28cb595a4.pdf";